<div>
  <canvas id="salesChart">{{salesChart}}</canvas>
</div>

